interface Dimension {
  id: string;
  nome: string;
  nome_grafico: string;
  descricao: string;
  cor_grafico: string;
}

export const DIMENSIONS: Record<string, Dimension> = {
  energia_social: {
    id: "energia_social",
    nome: "Energia Social",
    nome_grafico: "Energia Social",
    descricao: "Nível de extroversão e sociabilidade",
    cor_grafico: "#FF6B6B"
  },
  estabilidade_emocional: {
    id: "estabilidade_emocional", 
    nome: "Estabilidade Emocional",
    nome_grafico: "Estabilidade Emocional",
    descricao: "Capacidade de lidar com pressão e mudanças",
    cor_grafico: "#4ECDC4"
  },
  empatia_colaboracao: {
    id: "empatia_colaboracao",
    nome: "Empatia e Colaboração", 
    nome_grafico: "Empatia e Colaboração",
    descricao: "Foco em relacionamentos e trabalho em equipe",
    cor_grafico: "#45B7D1"
  },
  foco_disciplina: {
    id: "foco_disciplina",
    nome: "Foco e Disciplina",
    nome_grafico: "Foco e Disciplina", 
    descricao: "Organização e execução de tarefas",
    cor_grafico: "#F7DC6F"
  },
  criatividade_curiosidade: {
    id: "criatividade_curiosidade",
    nome: "Criatividade e Curiosidade",
    nome_grafico: "Criatividade e Curiosidade",
    descricao: "Abertura para novidades e soluções inovadoras",
    cor_grafico: "#BB8FCE"
  }
};

/**
 * Converte o ID da dimensão para o nome legível
 * @param dimensionId - O ID da dimensão (ex: "energia_social")
 * @returns O nome legível da dimensão (ex: "Energia Social") ou fallback
 */
export const getDimensionName = (dimensionId: string): string => {
  const dimension = DIMENSIONS[dimensionId];
  return dimension?.nome || "Avaliação de Perfil";
};

/**
 * Converte o ID da dimensão para o nome usado no gráfico
 * @param dimensionId - O ID da dimensão
 * @returns O nome para uso em gráficos
 */
export const getDimensionGraphName = (dimensionId: string): string => {
  const dimension = DIMENSIONS[dimensionId];
  return dimension?.nome_grafico || dimensionId;
};

/**
 * Obtém a cor da dimensão para uso em gráficos
 * @param dimensionId - O ID da dimensão
 * @returns A cor hexadecimal da dimensão
 */
export const getDimensionColor = (dimensionId: string): string => {
  const dimension = DIMENSIONS[dimensionId];
  return dimension?.cor_grafico || "#6B7280";
};

/**
 * Obtém a descrição da dimensão
 * @param dimensionId - O ID da dimensão
 * @returns A descrição da dimensão
 */
export const getDimensionDescription = (dimensionId: string): string => {
  const dimension = DIMENSIONS[dimensionId];
  return dimension?.descricao || "";
};